import { apiGetClient, apiPostClient, apiPutClient } from "../../api/apiSvtAdmin";
import { toast } from 'react-toastify';
import i18n from "i18next";
const t = i18n.t.bind(i18n);

const BASE_URL = `${process.env.REACT_APP_FOUNDATION_API_BASE_URL}/domainmaster`;

// Get all domains
export const getAllDomains = async () => {
    try {
        const response = await apiGetClient.get(`${BASE_URL}`);
        return response.data;
    } catch (error) {
        toast.error(error.response?.data?.error || "Failed to fetch domains.", { position: "top-center" });
        return null;
    }
};

// Get domain by ID
export const getDomainById = async (id) => {
    try {
        const response = await apiGetClient.get(`${BASE_URL}/${id}`);
        return response.data;
    } catch (error) {
        toast.error(error.response?.data?.error || "Failed to fetch domain details.", { position: "top-center" });
        return null;
    }
};

// Create new domain
export const createDomain = async (data) => {
    try {
        const response = await apiPostClient.post(`${BASE_URL}/add`, data);
        if (response?.data) {
            toast.success(t("domainCreatedSuccess"), { position: "top-center" });
            return response.data;
        } else {
            toast.error(t("unexpectedResponseStructure"), { position: "top-center" });
            return null;
        }
    } catch (error) {
        let errorData = error.response?.data;
        if (errorData?.errors) {
            Object.keys(errorData.errors).forEach((field) => {
                errorData.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response?.data?.error || "An error occurred.", { position: "top-center" });
        }
        return null;
    }
};

// Update domain
export const updateDomain = async (id, data) => {
    try {
        const response = await apiPutClient.put(`${BASE_URL}/update/${id}`, data);
    toast.success(t("domainUpdatedSuccess"), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response?.data;
        if (errorData?.errors) {
            Object.keys(errorData.errors).forEach((field) => {
                errorData.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response?.data?.error || "An error occurred.", { position: "top-center" });
        }
        return null;
    }
};